import filter from 'redux-storage-decorator-filter';
import createEngine from 'redux-storage-engine-localstorage';

function replacer(key, value) {
  if (key === 'error') {
    return {};
  }
  return value;
}

const engine = filter(createEngine('openbooksmd', replacer), ['token', 'currentUser']);

export default engine;



// WEBPACK FOOTER //
// ./app/lib/storageEngine.js